module.exports = __webpack_public_path__ + "media/images/no_result_sad_face-4222059ccb01ad0500a1f9c41320408b.png";